<template>
  <div class="split-screen">
    <div class="visual-side">
      <div class="visual-content">
        <div class="logo-circle">
          <svg viewBox="0 0 24 24" width="40" height="40" fill="white">
            <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z" />
          </svg>
        </div>
        <h1>Zucker<br>Ist Drüben.</h1>
        <p>Willkommen zurück.</p>
      </div>
      <div class="visual-bg"></div>
    </div>

    <div class="form-side">
      <div class="form-container">
        <div class="form-header">
          <h2>Anmelden</h2>
          <p>Bitte geben Sie Ihre Daten ein.</p>
        </div>

        <form @submit.prevent="login">
          <transition name="fade">
            <div v-if="checkLogin" class="error-banner">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg>
              <span>{{ checkLogin }}</span>
            </div>
          </transition>

          <div class="floating-group">
            <input 
              id="username"
              type="text" 
              v-model="userName" 
              placeholder=" " 
              autocomplete="username"
              required 
            />
            <label for="username">User ID</label>
          </div>

          <div class="floating-group">
            <input 
              id="password"
              :type="showPassword ? 'text' : 'password'" 
              v-model="password" 
              placeholder=" " 
              autocomplete="current-password"
              required 
            />
            <label for="password">Passwort</label>
            
            <button type="button" class="eye-btn" @click="togglePasswordVisibility">
              <svg v-if="showPassword" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" /></svg>
              <svg v-else viewBox="0 0 24 24" width="20" height="20" fill="#94a3b8"><path d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.27,4.73 8.04,5.16L10.12,7.24C10.7,7.09 11.32,7 12,7Z" /></svg>
            </button>
          </div>
          
          <button type="submit" class="submit-btn" :disabled="isLoading">
            <template v-if="!isLoading">
              Einloggen
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" /></svg>
            </template>
            <template v-else>
              <Login_Loader />
            </template>
          </button>
        </form>

        <div class="guest-section">
          <div class="separator-or">
            <span>oder</span>
          </div>

          <button type="button" class="guest-btn" @click="guestLogin" :disabled="isLoading">
            <template v-if="!isLoading">
              Als Gast fortfahren (Read Only)
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
              </svg>
            </template>
            <template v-else>
               Einen Moment...
            </template>
          </button>
        </div>

        <div class="footer-separator"></div>
        <p class="footer-text">© 2025/26 zuckeristdrueben.live</p>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Login_Loader from "./Login_Loader.vue";

export default {
  name: "LoginComponent",
  components: {
    Login_Loader
  },
  data() {
    return {
      userName: "",
      password: "",
      showPassword: false,
      checkLogin: "",
      isLoading: false,
    };
  },
  mounted() {
    document.body.classList.remove('dark-theme');
  },
  methods: {
    // Standard Login
    async login() {
      this.handleAuthRequest("/api/auth/login", {
        UsersID: this.userName, 
        password: this.password,
      });
    },
    
    // Guest Login via API
    async guestLogin() {
      this.handleAuthRequest("/api/auth/guest", {}); 
    },

    // Gemeinsame Logik für beide Login-Arten
    async handleAuthRequest(endpoint, payload) {
      this.checkLogin = "";
      this.isLoading = true;

      try {
        const response = await axios.post(endpoint, payload, { withCredentials: true });

        const { role, UsersID, UsersId } = response.data;
        
        localStorage.setItem("role", role);
        localStorage.setItem("UsersID", UsersID);
        if(UsersId) localStorage.setItem("UsersId", UsersId);
        
        axios.defaults.withCredentials = true; 

        if (localStorage.getItem('darkMode') === 'true') {
           document.body.classList.add('dark-theme');
        }

        this.$emit('login-success');

      } catch (error) {
        console.error(error);
        this.checkLogin = "Anmeldung fehlgeschlagen.";
      } finally {
        this.isLoading = false;
      }
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
/* --- Layout Grundgerüst --- */
.split-screen {
  display: flex;
  height: 100vh;
  width: 100vw;
  font-family: 'Inter', sans-serif;
  background-color: white;
  color: #0f172a;
  overflow: hidden;
}

.visual-side {
  flex: 1;
  background-color: #0f172a;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px;
  color: white;
  overflow: hidden;
}

.visual-bg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: radial-gradient(circle at 10% 20%, #1e293b 0%, #0f172a 90%);
  z-index: 1;
}

.visual-side::before {
  content: '';
  position: absolute;
  top: -100px; right: -100px;
  width: 400px; height: 400px;
  background: #198754;
  opacity: 0.1;
  filter: blur(80px);
  border-radius: 50%;
  z-index: 2;
}

.visual-content { position: relative; z-index: 10; max-width: 400px; }

.logo-circle {
  width: 64px; height: 64px;
  background: rgba(255,255,255,0.1);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  backdrop-filter: blur(10px);
}

.visual-content h1 {
  font-size: 3.8rem; font-weight: 700; line-height: 1.1; margin-bottom: 20px;
  background: -webkit-linear-gradient(#fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.visual-content p { color: #94a3b8; font-size: 1.05rem; line-height: 1.6; }

/* --- Formular Seite --- */
.form-side {
  flex: 0 0 500px;
  display: flex; align-items: center; justify-content: center;
  background-color: #ffffff;
  padding: 40px;
}

.form-container { width: 100%; max-width: 360px; }
.form-header { margin-bottom: 40px; }
.form-header h2 { font-size: 2.3rem; font-weight: 700; color: #0f172a; margin-bottom: 10px; }
.form-header p { color: #64748b; }

/* --- Inputs --- */
.floating-group {
  position: relative;
  margin-bottom: 24px;
}
.floating-group input {
  width: 100%;
  padding: 16px 16px 12px 16px; 
  font-size: 1.05rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background-color: #f8fafc;
  color: #0f172a;
  outline: none;
  transition: all 0.2s ease;
  box-sizing: border-box;
  height: 56px;
}
.floating-group label {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  font-size: 1.05rem;
  color: #64748b;
  pointer-events: none;
  transition: all 0.2s ease;
  background-color: transparent;
}
.floating-group input:focus, .floating-group input:not(:placeholder-shown) {
  border-color: #198754; background-color: #fff; padding-top: 24px; padding-bottom: 8px;
}
.floating-group input:focus + label, .floating-group input:not(:placeholder-shown) + label {
  top: 8px; left: 16px; transform: translateY(0); font-size: 0.75rem; font-weight: 600; color: #198754;
}

.eye-btn {
  position: absolute; right: 16px; top: 50%; transform: translateY(-50%);
  background: none; border: none; cursor: pointer; color: #64748b; display: flex; padding: 0; z-index: 5;
}

/* --- Buttons --- */
.submit-btn {
  width: 100%; padding: 16px;
  background-color: #0f172a; color: white;
  font-weight: 600; font-size: 1rem;
  border: none; border-radius: 12px;
  cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 10px;
  transition: all 0.2s; margin-top: 10px; min-height: 54px; 
}
.submit-btn:hover:not(:disabled) { background-color: #198754; transform: translateY(-1px); }

.guest-btn {
  width: 100%; padding: 14px;
  background-color: transparent; 
  color: #64748b;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-weight: 600; font-size: 0.95rem;
  cursor: pointer; 
  display: flex; align-items: center; justify-content: center; gap: 10px;
  transition: all 0.2s;
}
.guest-btn:hover:not(:disabled) {
  border-color: #94a3b8; color: #0f172a; background-color: #f8fafc;
}

.submit-btn:disabled, .guest-btn:disabled { opacity: 0.7; cursor: not-allowed; }

/* --- Separators --- */
.guest-section {
  margin-top: 24px;
  margin-bottom: 30px;
}

.separator-or {
  display: flex; align-items: center; text-align: center; color: #94a3b8; font-size: 0.9rem; margin-bottom: 24px;
}
.separator-or::before, .separator-or::after {
  content: ''; flex: 1; border-bottom: 1px solid #e2e8f0;
}
.separator-or span { margin: 0 12px; }

/* Die explizite Linie vor dem Footer */
.footer-separator {
  width: 100%;
  border-top: 1px solid #e2e8f0;
  margin-top: 40px; /* Großer Abstand zum Gast Button */
  margin-bottom: 20px; /* Kleiner Abstand zum Text */
}

.footer-text { text-align: center; font-size: 0.8rem; color: #94a3b8; }
.error-banner { background-color: #fef2f2; border: 1px solid #fecaca; color: #b91c1c; padding: 12px; border-radius: 8px; margin-bottom: 24px; font-size: 0.9rem; display: flex; align-items: center; gap: 10px; }

@media (max-width: 900px) {
  .split-screen { flex-direction: column; overflow-y: auto; }
  .visual-side { padding: 40px; min-height: 200px; flex: none; }
  .logo-circle { width: 48px; height: 48px; margin-bottom: 15px; }
  .visual-content h1 { font-size: 2.3rem; }
  .form-side { flex: 1; width: 100%; padding: 40px 20px; box-sizing: border-box; }
}
</style>